import _ from 'lodash';
import {
  InclusiveExclusiveFilterModel,
  GridFilterUnionModel,
  FilterPassParams
} from './filter-types';
import { FilterType } from '../../grid/utils/filter/filter.utils';
import { SetFilterValues } from 'ag-grid-community';
import { SimpleTextFilterValue } from '../../grid/types/filter.types';
import { SetFilterMutableOption } from '../../types/calendar.types';
import { FilterService } from './filter-service';
import { FilterResultFacade } from './filter-result-facade';
import { filterMaturities } from '../../grid/utils/filter/maturities-filters';

export function filterInclusiveExclusiveValues(
  model: InclusiveExclusiveFilterModel,
  values: string[],
  options: string[]
): boolean {
  let result = true;
  const filterValues = model.isInclusive
    ? model.values
    : excludeValues(options, model.storeValues);
  values = values ? values : [];
  result = values.some((val) => filterValues.indexOf(val) !== -1);
  return result;
}

export function isGridFilterActive(filter: GridFilterUnionModel): boolean {
  return (
    (filter && !_.has(filter, 'isFilterActive')) ||
    (_.has(filter, 'isFilterActive') && filter['isFilterActive'])
  );
}

export function excludeValues(from: string[], exclude: string[]): string[] {
  if (!from || !exclude) {
    return [];
  }
  const hash = exclude.reduce(
    (prev, value) => ({ ...prev, [value]: value }),
    {}
  );
  return from.filter(
    (item) => !Object.prototype.hasOwnProperty.call(hash, item)
  );
}

export function convertToStringArray(
  filterValues: SetFilterValues | SimpleTextFilterValue
): string[] {
  const filterValuesArray: any[] = _.values(filterValues);
  return filterValuesArray.map((item) => item.name);
}

export function isInstanceOfInclusiveExclusiveFilterModel(
  testObj: any
): boolean {
  if (!testObj) return false;
  const modelType: InclusiveExclusiveFilterModel = {
    filterType: FilterType.Set,
    isInclusive: true,
    storeValues: [],
    values: []
  };
  for (const key in modelType) {
    if (
      Object.prototype.hasOwnProperty.call(modelType, key) &&
      !Object.prototype.hasOwnProperty.call(testObj, key)
    ) {
      return false;
    }
  }
  return true;
}

export function convertOldSavedFilterToNewFormat(
  filterModel: any,
  options: string[]
) {
  const result: InclusiveExclusiveFilterModel = {
    filterType: FilterType.Set,
    isInclusive: true,
    storeValues: [],
    values: []
  } as InclusiveExclusiveFilterModel;
  if (Object.prototype.hasOwnProperty.call(filterModel, 'isInclusive')) {
    result.isInclusive = filterModel.isInclusive;
    if (filterModel.isInclusive) {
      if (Object.prototype.hasOwnProperty.call(filterModel, 'storeValues')) {
        result.values = filterModel.storeValues ? filterModel.storeValues : [];
        result.storeValues = filterModel.storeValues;
      } else {
        filterModel.values = filterModel.values
          ? filterModel.values
          : filterModel.value && Array.isArray(filterModel.value)
          ? filterModel.value
          : [];
        result.storeValues = filterModel.values ? filterModel.values : [];
        result.values = result.storeValues.slice();
      }
    } else {
      if (Object.prototype.hasOwnProperty.call(filterModel, 'storeValues')) {
        result.values = excludeValues(options, filterModel.storeValues);
        result.storeValues = filterModel.storeValues
          ? filterModel.storeValues
          : [];
      } else {
        if (
          Object.prototype.hasOwnProperty.call(filterModel, 'exclusiveValues')
        ) {
          result.storeValues = filterModel.exclusiveValues
            ? filterModel.exclusiveValues.slice()
            : [];
          result.values = excludeValues(options, result.storeValues);
        } else {
          result.storeValues = excludeValues(options, filterModel.values);
          result.values = filterModel.values ? filterModel.values : [];
        }
      }
    }
  } else {
    result.storeValues = filterModel.values ? filterModel.values.slice() : [];
    result.values = result.storeValues.slice();
  }
  for (const key in filterModel) {
    if (Object.prototype.hasOwnProperty.call(filterModel, key)) {
      if (!Object.prototype.hasOwnProperty.call(result, key)) {
        delete filterModel[key];
      }
    }
  }
  Object.assign(filterModel, result);
}

export function calculateIsInclusive(
  filterValues: string[],
  options: string[]
): boolean {
  const selectedCount = filterValues ? filterValues.length : 0;
  return !!(selectedCount / options.length <= 0.5);
}

export function calculateStoreValues(
  filterValues: string[],
  options: string[],
  isInclusive: boolean
): string[] {
  return isInclusive
    ? filterValues
      ? filterValues.slice()
      : []
    : excludeValues(options, filterValues);
}

export function getSetFiltersByColumn(
  filteredValue: string[],
  lookup: { [key: string]: string } = null
): { [key: string]: SetFilterMutableOption } {
  return filteredValue.reduce(
    (
      aggr: { [key: string]: { isPresent: boolean; name: string } },
      valueName: string
    ) => {
      aggr[valueName] = {
        isPresent: false,
        name: lookup ? lookup[valueName] : valueName
      };
      return aggr;
    },
    {}
  );
}

export function advancedFiltersPass(
  params: FilterPassParams,
  filterService: FilterService,
  filterResult: FilterResultFacade,
  underlyingView: boolean
): boolean {
  if (params.deal && params.deal.series && params.deal.maturities) {
    filterMaturities(params.deal, params.context, underlyingView);
  }

  const handlers = filterService.getHandlersForFiltering(params.filters);

  let handlersFilterPassed = true;
  handlersFilterPassed = !handlers.some(
    (handler) => !handler.doFilterPass(params, filterResult)
  );

  filterResult.completeDealFiltersPass(params.deal.id, handlersFilterPassed);
  return handlersFilterPassed;
}
